/** Small local icons keep the editor's controls available without an icon CDN. */
const paths = {
  face: 'M8 3h8a5 5 0 0 1 5 5v6a9 9 0 0 1-18 0V8a5 5 0 0 1 5-5ZM7 10h.01M17 10h.01M8 15q4 5 8 0M4 8q6 1 9-4 2 4 7 4',
  hair: 'M5 3a7 7 0 0 0 0 14M19 3a7 7 0 0 1 0 14M8 7q4-7 8 0M8 7v13m8-13v13m-4-16v16',
  eye: 'M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12ZM15 12a3 3 0 1 0-6 0 3 3 0 0 0 6 0Z',
  smile: 'M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0ZM7 9h.01M17 9h.01M7 14q5 7 10 0',
  shirt: 'm8 3-6 4 3 5 3-2v11h8V10l3 2 3-5-6-4q-4 5-8 0Z',
  glasses: 'M2 9h8v7H2Zm12 0h8v7h-8ZM10 11h4M2 9l2-5m18 5-2-5',
  palette:
    'M12 3a9 9 0 1 0 0 18h2q3 0 2-3t3-3q3 0 2-5-2-7-9-7ZM7 8h.01M12 6h.01M17 8h.01M6 13h.01',
  close: 'm6 6 12 12M6 18 18 6',
  shuffle: 'M3 6h3q3 0 6 6t6 6h3M3 18h3q3 0 6-6t6-6h3m-4-4 4 4-4 4m0 4 4 4-4 4',
  undo: 'M8 4 3 9l5 5M3 9h11a6 6 0 0 1 0 12',
  check: 'm5 12 4 4L19 6',
  verified: 'M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0ZM7 12l3 3 7-7',
  loading: 'M21 12a9 9 0 1 1-9-9',
  alert: 'M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0ZM12 7v6m0 4h.01',
  pencil: 'm4 16-1 5 5-1L21 7l-5-5ZM13 5l5 5',
} as const

export type AvatarIconName = keyof typeof paths

export function AvatarIcon({
  name,
  className,
}: {
  name: AvatarIconName
  className?: string
}) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className={className}
    >
      <path d={paths[name]} />
    </svg>
  )
}
